var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHeaderSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4F4F4F;}\r\n\t.st1{fill:#BCBCBC;}\r\n\t.st2{fill:#000066;}\r\n\t.st3{enable-background:new    ;}\r\n\t.st4{fill:#323232;}\r\n\t.st5{fill:#2EA0DC;}\r\n\t.st6{fill:url(#SVGID_1_);}\r\n\t.st7{opacity:0.3;fill:#B3B3E2;}\r\n\t.st8{fill:url(#SVGID_2_);}\r\n\t.st9{fill:none;}\r\n\t.st10{fill:#303096;}\r\n\t.st11{fill:url(#SVGID_3_);}\r\n\t.st12{fill:url(#SVGID_4_);}\r\n\t.st13{fill:url(#SVGID_5_);}\r\n\t.st14{fill:url(#SVGID_6_);}\r\n\t.st15{fill:url(#SVGID_7_);}\r\n\t.st16{fill:url(#SVGID_8_);}\r\n\t.st17{fill:url(#SVGID_9_);}\r\n\t.st18{fill:url(#SVGID_10_);}\r\n\t.st19{fill:#FFFFFF;}\r\n\t.st20{fill:url(#SVGID_11_);}\r\n\t.st21{fill:url(#SVGID_12_);}\r\n\t.st22{fill:url(#SVGID_13_);}\r\n\t.st23{fill:url(#SVGID_14_);}\r\n\t.st24{fill:url(#SVGID_15_);}\r\n\t.st25{fill:url(#SVGID_16_);}\r\n\t.st26{fill:url(#SVGID_17_);}\r\n\t.st27{fill:url(#SVGID_18_);}\r\n\t.st28{fill:url(#SVGID_19_);}\r\n\t.st29{fill:url(#SVGID_20_);}\r\n\t.st30{fill:url(#SVGID_21_);}\r\n\t.st31{fill:url(#SVGID_22_);}\r\n\t.st32{fill:url(#SVGID_23_);}\r\n\t.st33{fill:url(#SVGID_24_);}\r\n\t.st34{fill:url(#SVGID_25_);}\r\n\t.st35{fill:url(#SVGID_26_);}\r\n\t.st36{fill:url(#SVGID_27_);}\r\n\t.st37{fill:url(#SVGID_28_);}\r\n\t.st38{fill:url(#SVGID_29_);}\r\n\t.st39{fill:url(#SVGID_30_);}\r\n\t.st40{fill:url(#SVGID_31_);}\r\n\t.st41{fill:url(#SVGID_32_);}\r\n\t.st42{fill:url(#SVGID_33_);}\r\n\t.st43{fill:url(#SVGID_34_);}\r\n\t.st44{fill:url(#SVGID_35_);}\r\n\t.st45{fill:url(#SVGID_36_);}\r\n\t.st46{fill:url(#SVGID_37_);}\r\n\t.st47{fill:url(#SVGID_38_);}\r\n\t.st48{fill:url(#SVGID_39_);}\r\n\t.st49{fill:url(#SVGID_40_);}\r\n\t.st50{fill:#606060;}\r\n\t.st51{fill:url(#SVGID_41_);}\r\n\t.st52{fill:url(#SVGID_42_);}\r\n\t.st53{fill:url(#SVGID_43_);}\r\n\t.st54{fill:url(#SVGID_44_);}\r\n\t.st55{fill:url(#SVGID_45_);}\r\n\t.st56{fill:url(#SVGID_46_);}\r\n\t.st57{fill:url(#SVGID_47_);}\r\n\t.st58{fill:url(#SVGID_48_);}\r\n\t.st59{fill:url(#SVGID_49_);}\r\n\t.st60{fill:url(#SVGID_50_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1115,447C1115,446.9,1115,446.9,1115,447c-0.5,0.2-1,0.3-1.3,0.4c0,0,0,0,0,0 C1114.1,447.3,1114.5,447.1,1115,447z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391,528.5c-8.1,81.9-6.1,87.8-6.1,89.2c-0.1,2.5-0.2,5-0.2,7.5c4.1-7.4,30.2-55,41.7-75.5 c12.1-21.5,46.9-65.8,46.9-65.8s-66.9-7.2-130.6,17.6c-34.3,13.4-83.9,52.9-83.9,52.9l0.8,0.2c2.4-0.8,4.9-1.7,7.4-2.5 C306.7,539,354.4,526.3,391,528.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.9745,
    y1: 228.1755,
    x2: 923.1284,
    y2: 228.1755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#000066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#010156"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020249"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M554.5,228.6c0.8-0.3,1.5-0.6,2.3-0.9C556,228,555.2,228.3,554.5,228.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M548.8,231.1c1.9-0.8,3.7-1.7,5.6-2.5C552.6,229.4,550.7,230.3,548.8,231.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -134.0627,
    y1: 315.3158,
    x2: 921.6863,
    y2: 315.3158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#000066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#010156"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020249"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M918.7,211.5c-2.7-0.9-5.3-1.8-7.9-2.3c-85.8-15.8-171.9-20.3-258.2-5.6c-33.6,5.7-65.3,14.8-95.5,27.2 c-0.8,0.3-1.5,0.6-2.3,0.9c-1.9,0.8-3.7,1.6-5.6,2.4c-14,6.1-27.8,12.9-41.3,20.3c-2.1,1.2-4.3,2.4-6.4,3.7 c-2.1,1.2-4.2,2.4-6.3,3.6c-28.4,17-55.6,37.2-81.8,60.4c-1.7,1.5-3.8,2.8-5.7,4.2c0,0,0-0.1,0-0.1c-0.6-1.6,9.2-25.2,16.3-35.6 c7.2-10.7,16-20.4,24.6-31.2c-59.3-18.3-116.9-18.7-174.2,1.7c-32.3,11.5-59.5,31.3-89.5,53.5c79.2,11.2,138.2,40.8,150.7,121.4 c34.5-11.3,67-24.4,100.7-32.2c34-7.8,69.3-10.2,104.5-15.1c-4.6-23.1-7-46.6,0.5-72.6c6.4,20.1,10.7,38.1,18,54.7 c7.1,16.3,28.3,45.6,29.3,45.1c-10.3-40.5-17.8-81.2-7.9-123.3c9.1,38.7,23.4,74.5,49.9,107.5c-14.6-75.3-16.4-114-5.7-131.8 c9,26.1,17.6,51,26.8,77.6c2.2-15.9,3.4-29.5,6.2-42.9c0.9-4.5,5.1-9.3,8.6-12c12-9.4,23.5-16.4,37.8-23.5 c36.8-18.4,82-31.8,133.6-42.1c26.9-5.4,54.2-9.1,81.8-13.6C919.5,211.8,919.1,211.6,918.7,211.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M393.5,562.7c0.2-0.6,0.5-1.3,0.7-2c-0.2,0.6-0.4,1.1-0.6,1.7C393.5,562.5,393.5,562.6,393.5,562.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M393.3,563.1C393.3,563.1,393.3,563.1,393.3,563.1c0.1-0.1,0.1-0.3,0.2-0.4 C393.4,562.8,393.4,563,393.3,563.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M568.3,778.5c0.6,0.4,1.3,0.9,1.9,1.3C569.5,779.3,568.9,778.9,568.3,778.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M672.4,844.8c-0.4-5,0.2-10.3,2-15.4C672.6,834.8,672,840,672.4,844.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M574.8,782.8c2.9,1.8,5.9,3.5,9.1,5.1C580.8,786.3,577.8,784.5,574.8,782.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M584.1,787.9c0,0-0.1,0-0.1-0.1C584,787.9,584,787.9,584.1,787.9C584.1,787.9,584.1,787.9,584.1,787.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M570.2,779.8c1.5,1,3,2,4.7,3C573.2,781.8,571.7,780.8,570.2,779.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.1014,
    y1: 244.267,
    x2: 919.9401,
    y2: 244.267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#000066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#010156"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020249"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M508.1,254.4c13.5-7.4,27.2-14.2,41.3-20.3C535.3,240.2,521.5,246.9,508.1,254.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.1014,
    y1: 259.8965,
    x2: 919.9401,
    y2: 259.8965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#000066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#010156"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020249"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M495.4,261.7c2.1-1.2,4.2-2.4,6.3-3.6C499.6,259.3,497.5,260.5,495.4,261.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M501.7,258.1c2.1-1.2,4.3-2.5,6.4-3.7C505.9,255.6,503.8,256.9,501.7,258.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M201.9,575.3c11.5-3.7,35.9-13.5,65.2-23.3C238.9,561.3,214.9,570.7,201.9,575.3 C201.9,575.3,201.9,575.3,201.9,575.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.5912,
    y1: 664.5208,
    x2: 438.2073,
    y2: 664.5208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#000066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#010156"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020249"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M384.8,625.2c0-2.5,0.1-5,0.2-7.5c-0.1-1.5-2-7.4,6.1-89.2c-36.6-2.1-84.3,10.5-123.9,23.5 c-2.5,0.8-5,1.7-7.4,2.5c-26,8.9-47.3,17.3-57.8,20.7c0,0,0,0,0,0c-1.3,0.4-2.5,0.8-3.5,1.2c0,0,0,0,0-0.1 c-1.6,0.5-2.7,0.7-2.9,0.4c-2.2-2.3,61.6-81.8,99.6-114.4c-50.7,1.4-157.2,121.4-163.4,182.2c3.2-1.4,6.2-2.6,9.1-3.9 c49.9-21.9,101.2-39.3,155.3-47.8c10.4-1.6,13.1,1.2,13.5,10.9c0.5,12.6,1.7,25.3,3.8,37.8c15,89.8,55.9,165.3,124.9,225.1 C438.8,866,383.3,730.8,384.8,625.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.9,575.3C201.9,575.2,201.9,575.2,201.9,575.3c-1.4,0.4-2.5,0.8-3.5,1.1c0,0,0,0,0,0.1 C199.4,576.1,200.6,575.7,201.9,575.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M672.4,844.8c-0.4-5,0.2-10.3,2-15.4c4.8-14.3,15.6-24.7,25.8-39.6c-0.2,0-0.3,0.1-0.5,0.1 c0.1,0,0.3-0.1,0.4-0.1c-10.2,14.9-21,25.3-25.8,39.6C672.5,834.8,671.9,840,672.4,844.8c0.5,5.1,2.2,9.7,4.9,14l0-0.1 C674.7,854.5,672.9,849.8,672.4,844.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M623.2,796.8C623.2,796.8,623.2,796.8,623.2,796.8c0.1,0,0.2,0,0.2,0C623.4,796.8,623.3,796.8,623.2,796.8 C623.2,796.8,623.2,796.8,623.2,796.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.3288,
    y1: 944.0862,
    x2: 1068.4359,
    y2: 944.0862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.434346e-7,
    style: {
      stopColor: "#5CF9EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2915,
    style: {
      stopColor: "#47CFE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5757,
    style: {
      stopColor: "#35ADDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    style: {
      stopColor: "#2EA0DC"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M637.9,943.8c3.6,0.6,7.2,1.2,10.9,1.7c-3.5-0.9-6.9-1.8-10.3-2.9L637.9,943.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.36,
    y1: 624.8425,
    x2: 1321.9386,
    y2: 624.8425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.434346e-7,
    style: {
      stopColor: "#5CF9EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2915,
    style: {
      stopColor: "#47CFE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5757,
    style: {
      stopColor: "#35ADDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    style: {
      stopColor: "#2EA0DC"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M936,300.3c0,0-26.4,49.4-29.4,51.4c-0.8-4.2,11.9-31.1-16.2-39.5c-39.6-11.8-98.3,24.8-128.6,51.9l0.7,0.9 c65.8-32,139.2-34.3,114.1,15.3C839.5,454,711,483,688.3,494.8h0c-37.4,16-73.5,34.2-105.5,59.7c0,0-12.2,9.3-17.3,13.5 c-1.5,1.5-10.2,9.1-11.7,11.3c-10.1,14.6-27.7,45.4-31.9,59.3c-17.3,57.9,1.8,108.2,46.3,139.8c0.6,0.4,1.3,0.9,1.9,1.3 c1.5,1,3.1,2,4.7,3c2.9,1.8,6,3.5,9.1,5.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c12.6,4.5,25.3,8.5,39.1,8.8c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c24.8,0.6,49.2,0.9,76.3-6.9c0.2,0,0.3-0.1,0.5-0.1c-10.2,14.9-21,25.3-25.8,39.6c-1.7,5.2-2.3,10.4-2,15.4 c0.5,5.1,2.2,9.7,4.9,13.9l-38.9,84c3.4,1,6.9,2,10.3,2.9c17.2,2.6,34.8,4.1,52.7,3.9c147.9-1.8,180.4-48.9,231.6-84.7 c0,0,0.1-0.1,0.1-0.1c12.3-8.6,12.8-8.6,26.3-20.9c2.3-2.1,4.3-4.7,6.7-7.3c63.2-65.9,102.2-155.3,102.2-253.9 C1068.4,469,1016.9,367.6,936,300.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.3288,
    y1: 793.8217,
    x2: 1068.4359,
    y2: 793.8217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.434346e-7,
    style: {
      stopColor: "#5CF9EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2915,
    style: {
      stopColor: "#47CFE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5757,
    style: {
      stopColor: "#35ADDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    style: {
      stopColor: "#2EA0DC"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M623.4,796.8c24.7,2.3,49.2,0.9,76.3-6.9C672.6,797.7,648.2,797.4,623.4,796.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.5496,
    y1: 779.6151,
    x2: 1259.5857,
    y2: 779.6151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#000066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#010156"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020249"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M936.3,871.2c-1-2.2-2-4.4-3-6.7c-31.8-71.8-37.4-148-20.6-215.8c-74.9,60.4-115.3,142.6-103.9,215.5 c-39.3,13.6-88.1,21.4-108.7,12.4c-10-4.4-17.9-10.5-22.7-17.9c-2.7-4.2-4.4-8.9-4.9-14c-0.5-4.8,0.1-9.9,2-15.4 c4.8-14.3,15.6-24.7,25.8-39.6c-0.1,0-0.3,0.1-0.4,0.1c-27.2,7.8-51.5,7.5-76.3,6.9c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0 c-13.8-0.3-26.5-4.3-39.1-8.8c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c-3.2-1.6-6.2-3.3-9.1-5.1c-1.6-1-3.1-2-4.7-3 c-0.6-0.4-1.3-0.9-1.9-1.3c-44.5-31.6-63.8-142.2,15.3-224.6c-21.7,11.5-63.8,61-71.2,72c-77,114.3-20.1,242.4,74,293.3 c16.8,10.3,34.2,18,52.1,23.4c3.4,1,6.9,2,10.3,2.9c27.1,6.8,55.3,8.7,84.4,6.5c32.3,0,66.1-9.8,96.3-20.2c2-0.7,4.1-1.6,6.1-2.3 c41.2,56.7,120.9,83.3,209.1,74.1C1000.1,971.2,962,926.3,936.3,871.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.5361,
    y1: 572.4088,
    x2: 725.6733,
    y2: 572.4088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#000066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#010156"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020249"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M583.5,553.9c30.1,7.2,118.1,76.9,131.1,96.6c20.3-53.7,13.2-98.7-25.1-156.3 C652.1,510.2,615.5,528.5,583.5,553.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeaderSmall);
export default __webpack_public_path__ + "static/media/logo_header_small.a92cfab993207ac3cebd2148f5592921.svg";
export { ForwardRef as ReactComponent };